import {
  CATALOG_SERIES_DETAIL_SET_DATA,
  CATALOG_SERIES_DETAIL_RESET_DATA,
} from 'rebook/apps/catalog/constants';


const initialState = {
  series: null,
  books: null,
  paginateBy: 24,
  pageNumber: 1,
  lastPageNumber: 0,
  subscriptionId: null,
  bookListFetched: false,
  bookType: null,
};

export default function seriesDetail(state = initialState, action) {
  switch (action.type) {
    case CATALOG_SERIES_DETAIL_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case CATALOG_SERIES_DETAIL_RESET_DATA:
      return initialState;
    default:
      return state;
  }
}
